// extracted by mini-css-extract-plugin
module.exports = {"list":"_2PURiRb1xLcC7APVy9c9Uq","item":"_38N0Rp-3yRceqHgj8PTuWE","form-footer":"_2EWpPh_GsFqU82JSpzvKUw"};